import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// $FlowFixMe
import { useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import Layout from 'app/pages/Login/Layout';
import Authenticated from './Authenticated/Authenticated';
import { Tools } from './Tools/Tools.jsx';
import { setPathname } from 'app/store/reducers/router';
import { useDispatch } from 'react-redux';
const MainRoutes = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    useEffect(() => {
        dispatch(setPathname(location.pathname));
    }, [location]);
    return (_jsxs(Switch, { children: [_jsx(Route, { path: "/tools", component: Tools }), _jsx(Route, { path: "/authentication", component: Layout }), _jsx(Route, { path: "/", component: Authenticated })] }));
};
export default MainRoutes;
